<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">Readers Love Jamie Mayfield’s</span></p>
<p class="p1"><span class="t2">Waiting for Forever Series</span></p>
<p class="p2"><span class="t3">Choices</span></p>
<p class="p3">“I think kids should read these books if they are gay or if they are not. For gay kids, they can learn there is always someone that loves them no matter what. For the kids who aren’t gay, well, maybe they could see how bad they hurt people with their words. Even in 5th grade I heard people say “fag” and “homo.” We aren’t allowed to use words like that in my house and now I understand why. Words can hurt as much as hands or fists. So we should be careful how we use them.”</p>
<p class="p4">—Savannah, 12, The Novel Approach</p>
<p class="p2"><span class="t3">Destiny</span></p>
<p class="p3">“I cannot wait for the final installment to this trilogy and I highly recommend these books. Again, they are intense and graphic, but you can feel the love there as well. Mayfield shows both sides of the coin that is being gay and either accepted or denied by the people you love and trust.”</p>
<p class="p4">—MM Good Book Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?c44c6dce